import Navbar from "./Navbar_View";
import Footer from "./Contact_Footer_View";
import { useEffect } from "react";


export function Homescreen() 
{
    return (
        <>
            <Navbar />
          
            <div className="homepage-grid">
              <div className="picture-container homepage-grid--main-image" style={{ backgroundImage: `url(${require('./images/IMG-20240224-WA0003smaller.jpg')})` }} />

              <div className="homepage-grid--sub-images">
                <div className="picture-container" style={{ backgroundImage: `url(${require('./images/IMG-20240220-WA0047.jpg')})` }}/>
                <div className="picture-container" style={{ backgroundImage: `url(${require('./images/IMG-20240901-WA0011.jpg')})` }}/>
                <div className="picture-container" style={{ backgroundImage: `url(${require('./images/IMG-20240220-WA0044.jpg')})` }}/>
                <div className="picture-container" style={{ backgroundImage: `url(${require('./images/IMG-20240220-WA0001.jpg')})` }}/>
                <div className="picture-container" style={{ backgroundImage: `url(${require('./images/IMG-20240901-WA0015.jpg')})` }}/>
              </div>

              <div className="white-text-block">
                <h1 className="header-1">
                  Welkom bij Smaeck.
                </h1>
                <p>
                  Bij ons draait alles om passie en liefde voor het bakken.
                  In onze gezellige winkel vind je de heerlijkste zelfgemaakte gebakjes, koeken en taarten, allemaal met zorg en aandacht bereid.
                  Of je nu trek hebt in een heerlijk stuk taart, de lekkerste brownie of gewoon zin hebt in een knapperige koek bij de koffie - wij hebben het allemaal.<br></br><br></br>

                  Maar dat is nog niet alles. We nodigen je uit om onze rijkgevulde bonbons, romige chocolade en smeuïge nougat te ontdekken. Het perfecte cadeau voor jezelf of iemand die je dierbaar is.<br></br><br></br>

                  Wat onze winkel zo bijzonder maakt, is de persoonlijke touch en de huiselijke sfeer en dagelijks vers gebakken producten.
                  We zijn een kleine bakkerij en om verspilling tegen te gaan zijn de hoeveelheden beperkt.  Dus wilt u zeker zijn van iets lekkers aarzel niet om te bestellen. <br></br><br></br>

                  Kom langs bij Smaeck en laat je verleiden door onze zoete lekkernijen. We kunnen niet wachten om je te verwelkomen en je kennis te laten maken met de smaken die ons zo bijzonder maken.<br></br><br></br>

                  Tot snel!
                </p>
              </div>
            </div>
            
            <Footer />
        </>
    );
}

export default Homescreen;